<template>
  <div class="py-4 md:py-8">
    <div class="container mx-auto max-w-screen-xl" :class="model.background">
      <VcTypography :tag="model.heading" v-if="model.title" class="mb-5">
        {{ model.title }}
      </VcTypography>

      <div class="home-categories">
        <template v-for="(item, index) in model.newsItems" :key="index">
          <a
            :href="item.link"
            class="home-category-item relative flex items-center justify-center"
            :class="[`category${(index as number) + 1}`, { hasImageShadow: item.hasImageShadow === true }]"
            :style="{ backgroundImage: `url(${item.image})` }"
          >
            <div
              class="category__content z-[1] flex flex-col items-center justify-center text-center"
              :class="model.textColor ? model.textColor : 'text-white'"
            >
              <div
                class="category__title font-amaranth text-2xl font-semibold"
                :class="{ 'mb-4 text-3xl': index === 0 }"
              >
                {{ item.title }}
              </div>
              <div class="lg:text-lg">{{ item.subtitle }}</div>

              <VcButton
                v-if="item.buttonLabel"
                :to="item.link"
                size="md"
                color="custom"
                class="mt-4 bg-white px-8 py-2 text-[color:var(--body-text-color)] uppercase hover:bg-[color:var(--color-primary-500)] hover:text-white md:mt-12"
              >
                {{ item.buttonLabel }}
              </VcButton>
            </div>
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false });

defineProps({
  model: {
    type: Object,
    required: true,
  },
});
</script>

<style>
.home-categories {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 40px;
  grid-row-gap: 40px;
  grid-template-rows: 280px 280px;
  height: 600px;
  margin-bottom: -40px;
}

.home-category-item.hasImageShadow::after {
  content: "";
  background: rgba(0, 0, 0, 0.25);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  border-radius: 10px;
}

.category__content {
  position: absolute;
  height: 100%;
  top: 0;
  max-width: 80%;
  overflow: hidden;
}

.category1 {
  grid-area: 1 / 1 / 3 / 3;
  height: 600px;
}
.category2 {
  grid-area: 1 / 3 / 2 / 3;
  height: 280px;
}
.category3 {
  grid-area: 1 / 4 / 2 / 4;
  height: 280px;
}
.category4 {
  grid-area: 2 / 3 / 4 / 5;
  max-height: 280px;
  height: 100%;
}

.home-categories img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 2rem;
  object-fit: cover;
}

.category1,
.category2,
.category3,
.category4 {
  border-radius: 10px;
  background-size: cover;
  background-repeat: no-repeat;
}

.category__title {
  position: relative;
}

.category1 .category__content {
  padding-top: 150px;
}

.category2 .category__title::after,
.category3 .category__title::after,
.category4 .category__title::after {
  content: "";
  width: 100%;
  height: 2px;
  background: #fff;
  position: absolute;
  left: 0;
  bottom: -5px;
}

@media (max-width: 1024px) {
  .home-categories {
    display: flex;
    flex-direction: column;
    grid-row-gap: 20px;
    margin-bottom: -20px;
  }

  .category1 {
    max-height: 350px;
  }

  .category2,
  .category3,
  .category4 {
    height: 225px;
  }

  .category1 .category__content {
    padding-top: 0;
  }

  .category-title {
    left: 0.5rem;
    top: 0.5rem;
    font-size: 0.625rem;
    line-height: 1.2;
  }
}
</style>
